import { memo, useCallback } from 'react';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';

import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import { BtnResetFilter } from '@wconcept/wconcept-ui-renewal/components/atoms/svg';

import * as S from './style';

interface IProps {
  /** className */
  className?: string;
  /** items */
  items?: React.ReactNode;
  /** onReset */
  onReset?: () => void;
}

const FilterListBar = ({ className, items, onReset }: IProps) => {
  const isReset = useCallback(() => {
    if (items instanceof Array) {
      return !items.every(v => v.props.active === false);
    }
    return false;
  }, [items]);

  const cName = classNameBind(['filter-listbar', className || '']);

  return (
    <S.FilterListBar className={cName}>
      <S.Box className="inner">
        {isReset() && (
          <S.Left className="area-left">
            <Button
              label="필터 초기화"
              icon={<BtnResetFilter />}
              onClick={onReset}
            />
          </S.Left>
        )}
        <S.List className="list">{items}</S.List>
      </S.Box>
    </S.FilterListBar>
  );
};

export default memo(FilterListBar);
